import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import serverURL from '../config'; // Adjust the import based on your project structure
import toast from 'react-hot-toast'; // Import toast

const BulkQuesModal = ({ onClose, categoryId }) => {
    const [jsonInput, setJsonInput] = useState('');
    const [showPreview, setShowPreview] = useState(false);

    const handleSubmit = async () => {
        try {
            const questions = JSON.parse(jsonInput);
            const token = localStorage.getItem('token');

            await axios.post(`${serverURL}/questions/bulk-upload/${categoryId}`, questions, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            toast.success('Questions added successfully!');
            onClose();
        } catch (error) {
            console.error('Bulk upload failed:', error);
            toast.error('Failed to add bulk questions. Please check your input.');
        }
    };

    return (
        <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto w-full max-w-4xl mx-auto">
            <div className="flex justify-between items-center mb-6 pb-4 border-b border-campus-border">
                <h3 className="text-2xl font-heading font-bold text-campus-text-primary">Bulk Upload Questions</h3>
            </div>

            <div className="mb-6">
                <label htmlFor="jsonInput" className="block text-sm font-medium text-campus-text-primary mb-2">
                    Paste JSON Array
                </label>
                <textarea
                    id="jsonInput"
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                    rows="12"
                    className="w-full p-4 rounded-xl border border-campus-border bg-campus-bg text-sm font-mono text-campus-text-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition-all shadow-sm"
                    placeholder="Paste your JSON array here..."
                />
            </div>

            {/* Preview JSON Button */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-4 border-t border-campus-border">
                <button
                    className="w-full sm:w-auto px-5 py-2.5 bg-campus-surface border border-campus-border text-campus-text-primary rounded-lg hover:bg-campus-bg font-medium transition-colors shadow-sm"
                    onClick={() => setShowPreview(true)}
                >
                    Preview JSON Format
                </button>
                <div className="flex w-full sm:w-auto gap-3">
                    <button 
                        className="flex-1 sm:flex-none px-5 py-2.5 border border-campus-border text-campus-text-body rounded-lg hover:bg-campus-bg font-medium transition-colors" 
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button 
                        className="flex-1 sm:flex-none px-6 py-2.5 bg-campus-primary text-white rounded-lg hover:bg-campus-primary-dark font-medium transition-all shadow-sm" 
                        onClick={handleSubmit}
                    >
                        Submit Questions
                    </button>
                </div>
            </div>

            {/* Preview Modal */}
            {showPreview && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
                    <div className="bg-campus-surface p-6 sm:p-8 rounded-2xl shadow-soft w-full max-w-3xl max-h-[90vh] flex flex-col">
                        <h4 className="text-xl font-heading font-bold text-campus-text-primary mb-4 border-b border-campus-border pb-3">JSON Format Requirements</h4>
                        <div className="flex-grow overflow-auto mb-6">
                            <pre className="bg-campus-text-primary text-gray-100 p-4 rounded-xl overflow-x-auto text-sm font-mono shadow-inner">
                                {`[
                                {
                                    "category_id": 1,
                                    "question_text": "What is Node.js?",
                                    "points": 10,
                                    "question_type": "MCQ",
                                    "options": [
                                        {
                                            "option_text": "A runtime environment",
                                            "is_correct": true
                                        },
                                        {
                                            "option_text": "A programming language",
                                            "is_correct": false
                                        }
                                    ]
                                },
                                {
                                    "category_id": 1,
                                    "question_text": "Write a function to sort an array",
                                    "points": 20,
                                    "question_type": "Programming",
                                    "programming_details": {
                                        "programming_language": "Python",
                                        "input_format": "Array of integers",
                                        "output_format": "Sorted array",
                                        "sample_input": "[5,2,8,1,9]",
                                        "sample_output": "[1,2,5,8,9]",
                                        "time_limit": 1000,
                                        "memory_limit": 256
                                    },
                                    "test_cases": [
                                        {
                                            "input_data": "[5,2,8,1,9]",
                                            "expected_output": "[1,2,5,8,9]"
                                        },
                                        {
                                            "input_data": "[10,8,6,4,2]",
                                            "expected_output": "[2,4,6,8,10]"
                                        }
                                    ]
                                }
                            ]`}
                            </pre>
                        </div>
                        <div className="flex justify-end pt-4 border-t border-campus-border">
                            <button
                                className="px-6 py-2 border border-campus-border text-campus-text-primary rounded-lg hover:bg-campus-bg font-medium transition-colors"
                                onClick={() => setShowPreview(false)}
                            >
                                Close Preview
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

BulkQuesModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default BulkQuesModal;